import { TipoAccion, TipoAccionForm } from "../../types";
import { useForm } from "react-hook-form";
import { ROUTER_PATHS } from "@/shared";
import { useNavigate } from "react-router-dom";
import { CustomTextField, SingleFormBoxScene } from "@/shared/components/ui";
import { useEffect, useState } from "react";
import { useFetchPostTipoAccion, useFetchPutTipoAccion } from "@/shared/actions";
import { tipoAccionSchema } from "../../utils";
import { yupResolver } from "@hookform/resolvers/yup";

type SaveTipoAccionProps = {
  titulo: string;
  data?: TipoAccion | null;
};

export default function SaveTipoAccion({ titulo, data }: SaveTipoAccionProps) {
  const returnUrl = ROUTER_PATHS.control_cambios.tipoAccionNav;
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  const createTipoAccion = useFetchPostTipoAccion({ navigate, returnUrl });
  const updateTipoAccion = useFetchPutTipoAccion(navigate, returnUrl);

  const form = useForm<TipoAccionForm>({
    resolver: yupResolver(tipoAccionSchema) as any,
    mode: "onChange",
    defaultValues: {
      nombre: "",
      estado: true,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  const onSave = () => {
    if (!isValid) return;
    const values = { ...form.getValues() };
    if (data?.tipoAccionId) {
      return updateTipoAccion.mutate({
        id: data.tipoAccionId,
        data: values as any,
      });
    }
    return createTipoAccion.mutate(values);
  };

  useEffect(() => {
    if (data) {
      setShrink(true);
      reset({
        nombre: data.nombre ?? "",
        estado: data.estado ?? true,
      });
    }
  }, [data]);

  return (
    <SingleFormBoxScene
      titlePage={titulo}
      onCancel={() => navigate(returnUrl)}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre del tipo de acción"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ""}
        shrink={shrink}
      />
    </SingleFormBoxScene>
  );
}
